import { shortAddress } from "app/utils/shortAddress";
import { FC } from "react";
import styles from "./RunningLine.module.scss";

export interface IRunningLine {
  address: string;
  bought: string;
}

interface IRunningLineProps {
  purchases: IRunningLine[];
  ticker: string;
}

const RunningLine: FC<IRunningLineProps> = ({ purchases, ticker }) => {
  return (
    <div className={styles.tickerContainer}>
      <div className={styles.tickerContent}>
        {purchases.map((purchase: any, index: any) => (
          <span key={index} className={styles.tickerItem}>
            {shortAddress(purchase.address)} got {ticker} on $
            {purchase.bought.toFixed(2)}
            {index !== purchases.length - 1 && (
              <span className={styles.separator}> | </span>
            )}
          </span>
        ))}
      </div>
    </div>
  );
};

export default RunningLine;
